<template>
  <v-flex tag="li" class="d-flex container" xs6 md2>
    <v-avatar class="icon" size="none">
      <img :src="src" :alt="title" />
    </v-avatar>
    <em class="title dancing text-xs-center">{{ title }}</em>
  </v-flex>
</template>

<script>
export default {
  name: "Step",
  props: {
    src: { type: String, required: true },
    title: { type: String, required: true }
  }
};
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.icon img {
  max-width: 100%;
}
.title {
  display: block;
  font-style: normal;
}
</style>
